import { render, staticRenderFns } from "./AIAssisted.vue?vue&type=template&id=436d1d68&scoped=true"
import script from "./AIAssisted.vue?vue&type=script&lang=js"
export * from "./AIAssisted.vue?vue&type=script&lang=js"
import style0 from "./AIAssisted.vue?vue&type=style&index=0&id=436d1d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d1d68",
  null
  
)

export default component.exports